import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import addBtnIcon from 'utils/icon/icon_add-circle-blue.svg';
import { useTranslation } from 'react-i18next';

interface IProps {
  handleAddLanguage: () => void;
  title?: string;
}
const AddLanguageButton: React.FC<IProps> = ({ handleAddLanguage, title }) => {
  const { t } = useTranslation();
  return (
    <AddButton onClick={handleAddLanguage}>
      <img src={addBtnIcon} alt='add' />
      <p>{title ? title : t('buttons.addLang')}</p>
    </AddButton>
  );
};

export default AddLanguageButton;

const AddButton = styled.div`
  margin-top: 26px;
  margin-bottom: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: 6px;
  }
  p {
    color: ${theme.colors.blue_500};
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 24px;
    letter-spacing: 0.2px;
  }
`;
